import type { PumPreview, PumJumpSrpData } from '../types';

export interface SearchResultRepository {
    preview(data: PumPreview): Promise<PumJumpSrpData>;
}

export const SearchResultRepository = Symbol('SearchResultRepository');
